import Radio, { RadioProps } from '@mui/material/Radio';
import { styled } from '@mui/material/styles';

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 24,
  height: 24,
  backgroundColor: theme.palette.primary.light,
  'input:hover ~ &': {
    backgroundColor: '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: 'rgba(206,217,224,.5)',
  },
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const BpCheckedIcon = styled(BpIcon)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  '&:before': {
    display: 'block',
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.primary.light,
  },
}));

const PrimaryRadio = (props: RadioProps) => (
  <Radio
    sx={{
      '&:hover': {
        bgcolor: 'transparent',
      },
    }}
    disableRipple
    icon={<BpIcon />}
    checkedIcon={<BpCheckedIcon />}
    color="default"
    {...props}
  />
);

export default PrimaryRadio;
